exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svgIcon[data-v-c1529c14]{color:#a9b1c2;margin-left:2rem;:hover{color:#353d51}}.no-select[data-v-c1529c14]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);

// exports
